import isError from 'lodash/isError';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import AlertMessage from '~/components/data-display/AlertMessage';
import Modal from '~/components/modals/Modal/Modal';
import Text from '~/components/typographies/Text';
import i18n from '~/locales/i18n';
import styles from './ErrorBoundaryFallback.module.scss';
import Button from '../buttons/NewButton';

interface FallbackProps {
  error: unknown;
  resetError(): void;
}

export const ErrorBoundaryFallback = ({ error, resetError }: FallbackProps) => {
  // eslint-disable-next-line no-console
  console.log(error);
  return (
    <div className={styles.container}>
      <Text variant="title4" weight="semibold">
        {i18n.t('ENCOUNTERED_ERROR')}
      </Text>
      <AlertMessage box className={styles.error} size="large" type="warning">
        <pre>
          {isError(error)
            ? error.message
            : isString(error)
              ? error
              : isObject(error)
                ? JSON.stringify(error, null, 2)
                : i18n.t('ENCOUNTERED_ERROR')}
        </pre>
      </AlertMessage>
      <Button onClick={resetError}>{i18n.t('RESTORE')}</Button>
    </div>
  );
};

export const ModalErrorBoundaryFallback = ({ onClose, ...rest }: FallbackProps & { onClose: () => void }) => {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onClose();
    }
  };
  return (
    <Modal isOpen onOpenChange={handleOpenChange} aria-label={i18n.t('ENCOUNTERED_ERROR')}>
      <ErrorBoundaryFallback {...rest} />
    </Modal>
  );
};
